import React, { useState, useEffect } from 'react'
import { Pagination, Select, Button, Spin, message } from 'antd'
import { getListMex, exportListMex } from '../../../services/api/3dApi'
import ListMexTable from './ListMexTable'
import moment from "moment"
import { Link } from 'react-router-dom'
import FilterSelect from "../../shared/FilterSelect"
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import SearchField from '../../home/components/filters/SearchField'
import UseDebounce from '../../users/helpers/UseDebounce'
import { createJobExport } from '../../../helpers/createJobExport'
import { TAGS } from '../../batchesV3/components/filters/listOptions.json'

function ListMexPage() {
    const [listMex, setListMex] = useState([])
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [batchName, setBatchName] = useState('')
    const [listUser, setListUser] = useState([])
    const [user, setUser] = useState([])
    const [type, setType] = useState([])
    const [mexAt, setMexAt] = useState({})
    const [userCreate, setUserCreate] = useState('')
    const [tags, setTags] = useState([])
    const [loading, setLoading] = useState(false)

    const debounceBatchName = batchName === '' ? UseDebounce(batchName, 0) : UseDebounce(batchName, 500)
    const debounceUserCreate = userCreate === '' ? UseDebounce(userCreate, 0) : UseDebounce(userCreate, 500)

    const fetchListMex = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (batchName) payload.batch_name = batchName
            if (!!user && !!user.length) payload.user_mex = user
            if (!!type && !!type.length) payload.sku = type
            if (Object.keys(mexAt).length && !!mexAt.from && !!mexAt.to) {
                payload.mex_at = mexAt
            }
            if (userCreate) payload.user_create = userCreate
            if (tags && tags.length) payload.tags = tags

            const { data: res } = await getListMex(payload)
            const { data, success, message: mess } = { ...res }
            if (success) {
                setListMex(data.batches)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
                setListUser(data.users)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const handleBatchName = (field, value) => {
        setBatchName(value)
        setPage(1)
    }

    const handleChangeUser = (value) => {
        setUser(value)
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }
    const handleChangeMexAt = (field, value) => {
        setMexAt(value)
        setPage(1)
    }

    const exportMex = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (batchName) payload.batch_name = batchName
            if (!!user) payload.user_mex = user
            if (type.length) payload.sku = type
            if (Object.keys(mexAt).length && !!mexAt.from && !!mexAt.to) {
                payload.mex_at = mexAt
            }
            if (userCreate) payload.user_create = userCreate
            if (tags && tags.length) payload.tags = tags

            const { data: res } = await exportListMex(payload)
            if (typeof res !== 'string') {
                const { success, message: mess, data } = res
                if (!success) throw new Error(mess)

                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            } else {
                if (res) downloadFileFromData(res, { filename: `mex-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

        } catch (e) {
            setError(e.message)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const handleChangeInput = (field, value) => {
        if (field === 'user_create') setUserCreate(value)
        setPage(1)
    }

    const handleChangeSelect = (field, value) => {
        if (field === 'tags') setTags(value)
        setPage(1)
    }

    useEffect(() => {
        fetchListMex()
    }, [debounceBatchName, user, type, mexAt, limit, page, debounceUserCreate, tags])

    const { Option } = Select

    return (
        <div className='ListMexPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách ép mex</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportMex}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='mex'
                                disabled={loading}
                            >
                                Đánh dấu ép mex
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-2'>
                                <label className="d-block w-100 font-weight-bold mb-1">Tên lô</label>
                                <SearchField
                                    field='name'
                                    placeholder='Tìm kiếm theo tên Lô...'
                                    onChangeInput={handleBatchName}
                                />
                            </div>
                            <div className='col-12 col-xl-2'>
                                <label className="font-weight-bold mb-1">Ngày ép mex</label>
                                <FilterDateRangeV2
                                    field='packaged_at'
                                    onDatesChange={handleChangeMexAt}
                                    showTime={true}
                                />
                            </div>
                            <div className='col-12 col-xl-4'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>


                            <div className='col-12 col-xl-4'>
                                <div className="FilterSelect">
                                    <div className='font-weight-bold mb-1'>Người ép mex</div>
                                    <Spin spinning={loading}>
                                        <Select
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                            showArrow={true}
                                            placeholder="Vui lòng chọn người ép mex bạn muốn tìm kiếm"
                                            defaultValue={user}
                                            onChange={handleChangeUser}
                                            value={user || []}
                                            allowClear
                                        >
                                            {
                                                listUser.map((option, index) => {
                                                    return <Option key={index} value={option}>{option}</Option>
                                                })
                                            }
                                        </Select>
                                    </Spin>
                                </div>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block mb-1">Người tạo lô</label>
                                <SearchField
                                    field='user_create'
                                    placeholder='Tìm kiếm theo người tạo ...'
                                    onChangeInput={handleChangeInput}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="d-block w-100 font-weight-bold mb-1">Tags</label>
                                <Select
                                    value={tags || []}
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    placeholder='Chọn tag'
                                    allowClear
                                    filterOption={(input, option) =>
                                        option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                                    }
                                    onChange={(value) => handleChangeSelect('tags', value)}
                                >
                                    {Array.isArray(TAGS) && TAGS.length > 0 &&
                                        TAGS.map((item, index) =>
                                            <Option key={index} value={item.value}>
                                                {item.name}
                                            </Option>
                                        )
                                    }
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <ListMexTable
                            listMex={listMex}
                            setType={setType}
                            loading={loading}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListMexPage